(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    root.MdaSchedule = api;
    api.boot(window, document);
  }
})(typeof self !== 'undefined' ? self : this, function () {
  const STAMP = /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2})$/;
  const DEFAULT_TZ = 'America/New_York';

  function isValidStamp(s) {
    if (typeof s !== 'string') return false;
    const m = STAMP.exec(s);
    if (!m) return false;
    const y = +m[1], mo = +m[2], d = +m[3], h = +m[4], mi = +m[5];
    if (h > 23 || mi > 59) return false;
    const date = new Date(Date.UTC(y, mo - 1, d));
    return date.getUTCFullYear() === y && date.getUTCMonth() === mo - 1 && date.getUTCDate() === d;
  }

  function isBlank(s) {
    return s === undefined || s === null || String(s).trim() === '';
  }

  function isActive(start, end, now) {
    if (!isBlank(start) && !isValidStamp(start)) return null;
    if (!isBlank(end) && !isValidStamp(end)) return null;
    if (!isBlank(start) && now < start) return false;
    if (!isBlank(end) && now > end) return false;
    return true;
  }

  function nowStamp(date, tz) {
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: tz || DEFAULT_TZ,
      hourCycle: 'h23',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    }).formatToParts(date);
    const p = {};
    parts.forEach((x) => { p[x.type] = x.value; });
    return p.year + '-' + p.month + '-' + p.day + ' ' + p.hour + ':' + p.minute;
  }

  function stampToUtcMs(stamp) {
    const m = STAMP.exec(stamp);
    return Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5]);
  }

  function storeTimeToUtc(stamp, tz) {
    const wanted = stampToUtcMs(stamp);
    let result = wanted;
    for (let i = 0; i < 2; i++) {
      const offset = stampToUtcMs(nowStamp(new Date(result), tz)) - result;
      result = wanted - offset;
    }
    return new Date(result);
  }

  function previewNow(opts) {
    if (!opts.designMode && opts.isLive) return null;
    let fromQuery = null;
    try {
      fromQuery = new URLSearchParams(opts.search || '').get('mda_now');
    } catch (e) {}
    if (isValidStamp(fromQuery)) return fromQuery;
    if (isValidStamp(opts.settingNow)) return opts.settingNow;
    return null;
  }

  function applySchedules(root, now, opts) {
    const designMode = !!(opts && opts.designMode);
    const counts = { active: 0, inactive: 0, invalid: 0 };
    root.querySelectorAll('[data-mda-start], [data-mda-end]').forEach((el) => {
      const result = isActive(el.getAttribute('data-mda-start'), el.getAttribute('data-mda-end'), now);
      if (result === true) {
        counts.active++;
        el.hidden = false;
        el.removeAttribute('data-mda-inactive');
      } else {
        if (result === null) counts.invalid++;
        else counts.inactive++;
        el.hidden = true;
        el.setAttribute('data-mda-inactive', '');
      }
      if (result === null && designMode) {
        el.classList.add('mda-schedule-invalid');
        el.setAttribute('data-mda-schedule-error', 'Use YYYY-MM-DD HH:MM, Eastern time');
      } else {
        el.classList.remove('mda-schedule-invalid');
        el.removeAttribute('data-mda-schedule-error');
      }
    });
    return counts;
  }

  function boot(win, doc) {
    const config = win.MDA_SCHEDULE || {};
    const shopify = win.Shopify || {};
    const designMode = !!shopify.designMode;
    const isLive = !!(shopify.theme && shopify.theme.role === 'main');

    function run() {
      const now = previewNow({
        search: win.location.search,
        designMode: designMode,
        isLive: isLive,
        settingNow: config.previewNow || ''
      }) || nowStamp(new Date(), config.tz || DEFAULT_TZ);
      applySchedules(doc, now, { designMode: designMode });
      doc.dispatchEvent(new CustomEvent('mda:schedule-applied', { detail: { now: now } }));
    }

    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', run);
    else run();
    setInterval(run, 60000);
    doc.addEventListener('shopify:section:load', run);
  }

  return {
    isValidStamp: isValidStamp,
    isActive: isActive,
    nowStamp: nowStamp,
    storeTimeToUtc: storeTimeToUtc,
    previewNow: previewNow,
    applySchedules: applySchedules,
    boot: boot
  };
});
